import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { TargetService } from '@shared/target/target.service';
import { TargetClassForm, TargetCloseEnum } from '@shared/target/target.models';
import { Router } from '@angular/router';
import { Classroom } from '@shared/model/classroom.models';
import { ClassroomService } from '@shared/service/classroom.service';
import { NzMessageService } from 'ng-zorro-antd/message';

export interface TargetUser {
  userId: number;
  firstName: string;
  checked?: boolean;
}

@Component({
  selector: 'fl-create-target',
  templateUrl: './create-target.component.html',
  styleUrls: ['./create-target.component.scss'],

  standalone: false,
})
export class CreateTargetComponent implements OnInit {
  targetClassName: string;

  targetClassDescription: string;

  users: Array<TargetUser> = [];

  autoDestroy = false;

  enableTeacherAutoJoin = false;

  isSubmitting: boolean = false;

  // 是否创建成功
  isComplete: boolean = false;

  classroomId: number;

  // 班级列表
  classroomList: Classroom[];

  // 选中的靶向班
  selectClassroom: Classroom;

  selectClassroomId: number = null;

  TargetCloseEnum = TargetCloseEnum;

  tabIndex: number = 0;

  private drawerRef = inject(NzDrawerRef);
  private targetClassSrv = inject(TargetService);
  private router = inject(Router);
  private classroomSrv = inject(ClassroomService);
  private message = inject(NzMessageService);
  public cdr = inject(ChangeDetectorRef);

  async ngOnInit() {
    await this.loadClassroomList();
  }

  onRemoveUser(index: number) {
    this.users.splice(index, 1);
  }

  close(closeEnum: TargetCloseEnum) {
    this.drawerRef.close(closeEnum);
  }

  submit() {
    if (this.tabIndex === 0 && !this.targetClassName.trim()) {
      this.message.create('error', '班级名称不能为空');
      return;
    }
    if (this.tabIndex === 1 && !this.selectClassroomId) {
      this.message.create('error', '请选择班级');
      return;
    }
    if (this.users?.length <= 0) {
      this.message.create('error', '请选择学生');
      return;
    }
    this.targetClassSrv.submitSubject.next(this.getOptionData());
  }

  getOptionData(): TargetClassForm {
    return {
      targetClassName: this.targetClassName,
      targetClassDescription: this.targetClassDescription,
      autoDestroy: this.autoDestroy,
      enableTeacherAutoJoin: this.enableTeacherAutoJoin,
      userIds: this.users.map(itr => itr.userId),
      classroomId: this.selectClassroomId,
    };
  }

  async loadClassroomList() {
    const classroomList = (await this.classroomSrv.getList(false)).results;
    // 只看靶向班
    this.classroomList = classroomList.filter(x => x.type === 2);
    // 班级列表经请求返回后写入（ngOnInit 的 await 续体），超出模板事件链，需主动标记
    this.cdr.markForCheck();
  }

  onClassroomChange(classroom: Classroom) {
    if (this.selectClassroomId !== null && this.selectClassroom?.id === classroom.id) {
      this.selectClassroomId = null;
      return;
    }
    this.selectClassroom = classroom;
    this.selectClassroomId = classroom.id;
    this.classroomList.forEach(item => {
      if (classroom.id !== item.id) item.checked = false;
    });
  }

  async navToUrl(urlType: string = '') {
    await this.close(TargetCloseEnum.FINISH);
    const urlMap = {
      class: `/classroom/${this.selectClassroomId}`,
      material: '/exercise/by-material',
      tk: '/tk',
      course: '/course',
    };
    if (urlMap.hasOwnProperty(urlType)) {
      await this.router.navigateByUrl(urlMap[urlType]);
    }
  }
}
